
import { split, join, concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { toLocalTime, toString } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { createElement } from "react";
import React from "react";
import { ErrorAlert, SuccessAlert, InformationAlert } from "../../../Components/Alert.js";
import { defaultOf } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { useTranslation } from "react-i18next";
import { WizardMode, VerificationModule_isVerified, WizardStepModule_back, Msg, WizardStepModule_key, WizardStepModule_forMode } from "./Types.js";
import { singleton as singleton_1, indexed, ofArray, findIndex } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { int32ToString, createObj, equals } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty, append, singleton, collect, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { LabeledInlineValue, TextValue } from "../../../Components/Text.js";
import { PasswordInput } from "../../../Components/Input.js";
import { FormState__getValidation } from "../../../Shared/Shared.js";
import { map, defaultArg, unwrap } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { TextButton, Button } from "../../../Components/Button.js";
import { ConfirmationDialog, Dialog } from "../../../Components/Dialog.js";
import { TelematicsProvider__ToI18nString } from "../../../Shared/Telematics.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";

function keyDisplay(prefix) {
    if (prefix === "") {
        return "…";
    }
    else {
        return concat(prefix, ..."_…");
    }
}

function dateTime(value) {
    return toString(toLocalTime(value), "dd.MM.yyyy HH:mm");
}

function componentState(formState) {
    if (formState.IsLoading) {
        return "disabled";
    }
    else {
        return "enabled";
    }
}

function verificationAlert(t, successText, verification) {
    switch (verification.tag) {
        case 1:
            return createElement(InformationAlert, {
                Label: t("telematics.wizard.verifying"),
            });
        case 2:
            return createElement(SuccessAlert, {
                Label: successText(verification.fields[0].TrackerCount),
            });
        case 3:
            return createElement(ErrorAlert, {
                Label: t(verification.fields[0]),
            });
        default:
            return defaultOf();
    }
}

function StepIndicator(props) {
    let elems_1;
    const patternInput = useTranslation();
    const steps = WizardStepModule_forMode(props.Mode);
    const currentIndex = findIndex((y) => equals(props.Step, y), steps) | 0;
    return reactElement("ol", createObj(ofArray([["className", join(" ", ["mb-6", "flex", "gap-4", "text-sm"])], ["data-test-id", "telematics-wizard-steps"], (elems_1 = toList(delay(() => collect((matchValue) => {
        let elems;
        const step = matchValue[1];
        const index = matchValue[0] | 0;
        return singleton(reactElement("li", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", (index === currentIndex) ? "font-semibold" : "text-gray-500"])], ["data-test-id", concat("telematics-wizard-step-", ...WizardStepModule_key(step))], (elems = [reactElement("span", {
            className: join(" ", ["flex", "h-6", "w-6", "items-center", "justify-center", "rounded-full", "border", (index <= currentIndex) ? "bg-primary text-white border-primary" : "border-gray-300"]),
            children: int32ToString(index + 1),
        }), reactElement("span", {
            children: patternInput[0](concat("telematics.wizard.step_", ...WizardStepModule_key(step))),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
    }, indexed(steps)))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function providerStep(t, host) {
    let elems_1, elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["rounded", "border", "border-primary", "p-4"])], ["data-test-id", "telematics-wizard-provider-telematic-one"], (elems = [createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: t("telematics.provider.telematic_one"),
    }), reactElement("div", {
        className: join(" ", ["text-sm", "text-gray-600"]),
        children: host,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function credentialsStep(t, host, wizard, formState, dispatch) {
    let elems_1, Label, ValidationMessage, elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_1 = [createElement(PasswordInput, (Label = t("telematics.wizard.api_key"), (ValidationMessage = FormState__getValidation(formState, t, "api_key"), {
        ComponentState: componentState(formState),
        Label: Label,
        OnChange: (arg) => {
            dispatch(new Msg(6, [arg]));
        },
        OnSetPasswordVisible: () => {
            dispatch(new Msg(7, []));
        },
        PasswordVisible: wizard.ApiKeyVisible,
        TestId: "telematics-wizard-api-key",
        ValidationMessage: unwrap(ValidationMessage),
        Value: wizard.ApiKey,
    }))), reactElement("div", createObj(ofArray([["className", join(" ", ["text-sm", "text-gray-500"])], (elems = [reactElement("span", {
        children: t("telematics.wizard.api_key_hint"),
    }), " ", reactElement("a", {
        className: join(" ", ["underline"]),
        href: concat(host, ..."/api-docs"),
        target: "_blank",
        rel: "noopener noreferrer",
        "data-test-id": "telematics-wizard-api-docs-link",
        children: t("telematics.wizard.api_docs_link"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function verifyStep(t, successText, wizard, formState, dispatch) {
    let elems_2, elems, Label, elems_1;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_2 = [reactElement("div", {
        className: join(" ", ["text-sm"]),
        children: t("telematics.wizard.verify_hint"),
    }), reactElement("div", createObj(singleton_1((elems = [createElement(Button, (Label = t("telematics.wizard.verify_button"), {
        ComponentState: componentState(formState),
        Label: Label,
        OnClick: () => {
            dispatch(new Msg(8, []));
        },
        TestId: "telematics-wizard-verify-button",
        Variant: "secondary",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])))), reactElement("div", createObj(ofArray([["data-test-id", "telematics-wizard-verify-result"], (elems_1 = [verificationAlert(t, successText, wizard.Verification)], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function summaryStep(t, host, wizard, existing) {
    let elems;
    let prefix;
    const matchValue = wizard.ApiKey.trim();
    let matchResult, apiKey;
    if (matchValue === "") {
        if (existing != null) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
            apiKey = matchValue;
        }
    }
    else {
        matchResult = 1;
        apiKey = matchValue;
    }
    switch (matchResult) {
        case 0: {
            prefix = existing.ApiKeyPrefix;
            break;
        }
        default: {
            const matchValue_2 = split(apiKey, ["_"], undefined, 0);
            prefix = ((matchValue_2.length >= 4) ? join("_", matchValue_2.slice(0, 2 + 1)) : "");
        }
    }
    let trackerCount;
    const matchValue_3 = wizard.Verification;
    trackerCount = ((matchValue_3.tag === 2) ? int32ToString(matchValue_3.fields[0].TrackerCount) : "–");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems = [LabeledInlineValue({
        Label: t("settings.telematics.provider"),
        TestId: "telematics-wizard-summary-provider",
        Value: t("telematics.provider.telematic_one"),
    }), LabeledInlineValue({
        Label: t("settings.telematics.host"),
        TestId: "telematics-wizard-summary-host",
        Value: host,
    }), LabeledInlineValue({
        Label: t("settings.telematics.api_key"),
        TestId: "telematics-wizard-summary-key",
        Value: keyDisplay(prefix),
    }), LabeledInlineValue({
        Label: t("telematics.wizard.summary_tracker_count"),
        TestId: "telematics-wizard-summary-trackers",
        Value: trackerCount,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function WizardDialog(props) {
    let Title;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const wizard = props.Wizard;
    const state = componentState(props.FormState);
    const isFirst = WizardStepModule_back(wizard.Mode, wizard.Step) == null;
    let canContinue;
    const matchValue = wizard.Step;
    canContinue = ((matchValue.tag === 1) ? (wizard.ApiKey.trim() !== "") : ((matchValue.tag === 2) ? VerificationModule_isVerified(wizard.Verification) : ((matchValue.tag === 3) ? VerificationModule_isVerified(wizard.Verification) : true)));
    return createElement(Dialog, (Title = ((wizard.Mode.tag === 1) ? t("telematics.wizard.title_change_key") : t("telematics.wizard.title_setup")), {
        Body: toList(delay(() => append(singleton(createElement(StepIndicator, {
            Mode: wizard.Mode,
            Step: wizard.Step,
        })), delay(() => {
            let matchValue_2;
            return append((matchValue_2 = wizard.Step, (matchValue_2.tag === 1) ? singleton(credentialsStep(t, props.Host, wizard, props.FormState, props.Dispatch)) : ((matchValue_2.tag === 2) ? singleton(verifyStep(t, (count) => {
                const arg_1 = {
                    count: count,
                };
                return patternInput[1].t("telematics.wizard.verify_success", arg_1);
            }, wizard, props.FormState, props.Dispatch)) : ((matchValue_2.tag === 3) ? singleton(summaryStep(t, props.Host, wizard, props.Existing)) : singleton(providerStep(t, props.Host))))), delay(() => {
                const matchValue_3 = FormState__getValidation(props.FormState, t, "global");
                return (matchValue_3 == null) ? singleton(defaultOf()) : singleton(createElement(ErrorAlert, {
                    Label: matchValue_3,
                }));
            }));
        })))),
        Controls: toList(delay(() => append(singleton(createElement(TextButton, {
            ComponentState: state,
            Label: t("general.cancel"),
            OnClick: () => {
                props.Dispatch(new Msg(3, []));
            },
            TestId: "telematics-wizard-cancel",
            Variant: "blueButton",
        })), delay(() => append(!isFirst ? singleton(createElement(TextButton, {
            ComponentState: state,
            Label: t("general.back"),
            OnClick: () => {
                props.Dispatch(new Msg(5, []));
            },
            TestId: "telematics-wizard-back",
            Variant: "blueButton",
        })) : empty(), delay(() => ((wizard.Step.tag === 3) ? singleton(createElement(TextButton, {
            ComponentState: canContinue ? state : "disabled",
            Label: t("telematics.wizard.save"),
            OnClick: () => {
                props.Dispatch(new Msg(10, []));
            },
            TestId: "telematics-wizard-save",
            Variant: "blueButton",
        })) : singleton(createElement(TextButton, {
            ComponentState: canContinue ? state : "disabled",
            Label: t("general.next"),
            OnClick: () => {
                props.Dispatch(new Msg(4, []));
            },
            TestId: "telematics-wizard-next",
            Variant: "blueButton",
        }))))))))),
        IsOpen: true,
        OnClose: () => {
            props.Dispatch(new Msg(3, []));
        },
        Title: Title,
    }));
}

function NotConnected(props) {
    let elems_1, elems, Label;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], ["data-test-id", "telematics-not-connected"], (elems_1 = [reactElement("div", {
        className: join(" ", ["text-sm"]),
        children: t("settings.telematics.description"),
    }), reactElement("div", {
        className: join(" ", ["text-sm", "text-gray-500"]),
        children: t("settings.telematics.not_connected"),
    }), reactElement("div", createObj(singleton_1((elems = [createElement(Button, (Label = t("settings.telematics.setup"), {
        ComponentState: componentState(props.FormState),
        Label: Label,
        OnClick: () => {
            props.Dispatch(new Msg(2, [new WizardMode(0, [])]));
        },
        TestId: "telematics-setup-button",
        Variant: "primary",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function Connected(props) {
    let elems_3, elems, elems_1, elems_2, Title, arg_3;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const i18n = patternInput[1];
    const connection = props.Connection;
    const state = componentState(props.FormState);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], ["data-test-id", "telematics-connected"], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems = toList(delay(() => append(singleton(LabeledInlineValue({
        Label: t("settings.telematics.provider"),
        TestId: "telematics-provider",
        Value: t(TelematicsProvider__ToI18nString(connection.Provider)),
    })), delay(() => append(singleton(LabeledInlineValue({
        Label: t("settings.telematics.host"),
        TestId: "telematics-host",
        Value: connection.ProviderHost,
    })), delay(() => append(singleton(LabeledInlineValue({
        Label: t("settings.telematics.api_key"),
        TestId: "telematics-api-key-prefix",
        Value: keyDisplay(connection.ApiKeyPrefix),
    })), delay(() => append(singleton(LabeledInlineValue({
        Label: t("settings.telematics.verified_at"),
        TestId: "telematics-verified-at",
        Value: defaultArg(map(dateTime, connection.VerifiedAt), t("settings.telematics.never_verified")),
    })), delay(() => append(singleton(LabeledInlineValue({
        Label: t("settings.telematics.active_assignments"),
        TestId: "telematics-active-assignments",
        Value: int32ToString(connection.ActiveAssignments),
    })), delay(() => ((connection.LastError !== "") ? singleton(createElement(ErrorAlert, {
        Label: defaultArg(map((at) => concat(dateTime(at), ": ", ...t(connection.LastError)), connection.LastErrorAt), t(connection.LastError)),
    })) : empty()))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["data-test-id", "telematics-test-result"], (elems_1 = [verificationAlert(t, (count) => {
        const arg_1 = {
            count: count,
        };
        return i18n.t("telematics.wizard.verify_success", arg_1);
    }, props.StoredKeyTest)], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-3"])], (elems_2 = [createElement(Button, {
        ComponentState: state,
        Label: t("settings.telematics.test"),
        OnClick: () => {
            props.Dispatch(new Msg(12, []));
        },
        TestId: "telematics-test-button",
        Variant: "secondary",
    }), createElement(Button, {
        ComponentState: state,
        Label: t("settings.telematics.change_key"),
        OnClick: () => {
            props.Dispatch(new Msg(2, [new WizardMode(1, [])]));
        },
        TestId: "telematics-change-key-button",
        Variant: "secondary",
    }), createElement(Button, {
        ComponentState: state,
        Label: t("settings.telematics.disconnect"),
        OnClick: () => {
            props.Dispatch(new Msg(14, []));
        },
        TestId: "telematics-disconnect-button",
        Variant: "redButton",
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement(ConfirmationDialog, (Title = t("settings.telematics.disconnect_title"), {
        Description: (arg_3 = {
            count: connection.ActiveAssignments,
        }, i18n.t("settings.telematics.disconnect_description", arg_3)),
        FormState: props.FormState,
        IsOpen: props.IsDisconnectDialogOpen,
        OnClose: () => {
            props.Dispatch(new Msg(15, []));
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(16, []));
        },
        Title: Title,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function LoadFailed(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], ["data-test-id", "telematics-load-failed"], (elems_1 = [createElement(ErrorAlert, {
        Label: t("settings.telematics.load_failed"),
    }), reactElement("div", createObj(singleton_1((elems = [createElement(Button, {
        ComponentState: "enabled",
        Label: t("settings.telematics.reload"),
        OnClick: () => {
            props.Dispatch(new Msg(1, []));
        },
        TestId: "telematics-reload-button",
        Variant: "secondary",
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function TelematicsSettings() {
    let elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const matchValue = state_1.Overview;
    if (matchValue.tag === 1) {
        const overview = matchValue.fields[0];
        const connection = overview.Connection;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-5"])], (elems = toList(delay(() => {
            let matchValue_1;
            return append((matchValue_1 = connection, (matchValue_1 != null) ? singleton(createElement(Connected, {
                Connection: matchValue_1,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                IsDisconnectDialogOpen: state_1.IsDisconnectDialogOpen,
                StoredKeyTest: state_1.StoredKeyTest,
            })) : singleton(createElement(NotConnected, {
                Dispatch: dispatch,
                FormState: state_1.FormState,
            }))), delay(() => {
                const matchValue_2 = state_1.Wizard;
                return (matchValue_2 == null) ? singleton(defaultOf()) : singleton(createElement(WizardDialog, {
                    Dispatch: dispatch,
                    Existing: unwrap(connection),
                    FormState: state_1.FormState,
                    Host: overview.ProviderHost,
                    Wizard: matchValue_2,
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
    else if (state_1.LoadFailed) {
        return createElement(LoadFailed, {
            Dispatch: dispatch,
        });
    }
    else {
        return defaultOf();
    }
}

